module.exports = __webpack_public_path__ + "img/r-209.0e4ca9d4.jpg";